module.exports = "<ion-view\r\n  title=\"{{'app.settings.file.uploads.pending.header.label' | translate}}\"\r\n  hide-nav-bar=\"true\"\r\n  cache-view=\"false\"\r\n>\r\n  <settings-view-uploads-header\r\n    on-click-retry=\"retryUploads\"\r\n  >\r\n  </settings-view-uploads-header>\r\n\r\n  <ion-content padding=\"true\" class=\"has-react-header\">\r\n\r\n    <pending-upload-item ng-repeat=\"it in uploads\" model=\"it\" default-mode=\"list\"></pending-upload-item>\r\n\r\n  </ion-content>\r\n</ion-view>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/js/settings/controllers/pending-uploads.html
// module id = 2997
// module chunks = 0